interface BiUser {
  permissions?: string[];
}

interface BiReportAccess {
  permissions: string[];
  status?: boolean;
}

// Mesma regra que o menu do BI sempre usou (`<Can permissions={...}>` →
// `useCan`): o usuário precisa ter todas as permissões vinculadas ao
// relatório; relatório sem permissão vinculada fica visível para todos; roles
// não entram na regra. A única novidade é esconder o relatório que o
// administrador desativou.
export function canSeeBiReport(
  user: BiUser | undefined | null,
  report: BiReportAccess,
): boolean {
  if (!user) {
    return false;
  }

  if (report.status === false) {
    return false;
  }

  const required = report.permissions || [];

  if (required[0] === 'access_full') {
    return true;
  }

  const userPermissions = user.permissions || [];

  return required.every(permission => userPermissions.includes(permission));
}

// Filial do setor do usuário (`sectors.branch`, texto). Só vale número inteiro:
// vazio ou nulo viraria 0 com `Number(...)` e abriria o relatório filtrado por
// uma filial que não existe, em branco e sem explicação. `NaN` = sem filial.
export function parseBranch(raw: unknown): number {
  const text = raw === null || raw === undefined ? '' : String(raw).trim();

  return /^\d+$/.test(text) ? Number(text) : NaN;
}

// Mesma comparação da API (UpdatePowerBiCommentStatusService): sem diferenciar
// maiúsculas e ignorando espaços nas pontas.
export function canManageBi(user: BiUser | undefined | null): boolean {
  return (user?.permissions || []).some(
    permission => (permission || '').trim().toLowerCase() === 'user_adm',
  );
}
